import { Component } from '@angular/core';

@Component({
  selector: 'app-rp-trusted-by-section',
  templateUrl: './trusted-by-section.component.html',
  styleUrls: ['./trusted-by-section.component.scss'],
})
export class TrustedBySectionComponent {
  companyLogos = [
    { src: 'assets/images/company-logos/logo-1.png', alt: 'Company 1' },
    { src: 'assets/images/company-logos/logo-2.png', alt: 'Company 2' },
    { src: 'assets/images/company-logos/logo-3.png', alt: 'Company 3' },
    { src: 'assets/images/company-logos/logo-4.png', alt: 'Company 4' },
    { src: 'assets/images/company-logos/logo-5.png', alt: 'Company 5' },
    { src: 'assets/images/company-logos/logo-6.png', alt: 'Company 6' },
    { src: 'assets/images/company-logos/logo-7.png', alt: 'Company 7' },
    { src: 'assets/images/company-logos/logo-9.png', alt: 'Company 9' },
  ];
}
